export const INFO = 'info';
export const ADVERTENCIA = 'warn';
export const ERROR = 'error';
export const EXITO = 'success';